import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../shared/services/modal.service';
import { LicenceModalComponent } from '../access-data/components/licence-modal/licence-modal.component';
import { PrivacyModalComponent } from '../access-data/components/privacy-modal/privacy-modal.component';

@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.scss'],
})
export class TermsConditionsComponent implements OnInit {
  constructor(private modalService: ModalService) {}

  ngOnInit() {}

  openLicenseTermsModal(): void {
    this.modalService.openModal(LicenceModalComponent);
  }

  openPrivacyModal(): void {
    this.modalService.openModal(PrivacyModalComponent);
  }
}
